import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";

import { AuthCallback } from "@/pages/AuthCallback";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import Market from "@/pages/Market";
import Cart from "@/pages/Cart";
import SharedBasket from "@/pages/SharedBasket";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Orders from "@/pages/Orders";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";

function Splash() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-[#095F2E] to-[#0B7A3B]">
      <img src="/logo.png" alt="Pepperonni Market" className="w-24 h-24 rounded-2xl animate-pulse" />
      <p className="text-white/80 mt-4 font-semibold">Loading market…</p>
    </div>
  );
}

function Protected({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready || user === null) return <Splash />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/market" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/market" element={<Market />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/basket/:code" element={<SharedBasket />} />
      <Route path="/checkout" element={<Protected><Checkout /></Protected>} />
      <Route path="/order-success/:orderId" element={<Protected><OrderSuccess /></Protected>} />
      <Route path="/orders" element={<Protected><Orders /></Protected>} />
      <Route path="/profile" element={<Protected><Profile /></Protected>} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<Navigate to="/market" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <div className="min-h-screen">
            <AppRoutes />
            <Toaster position="top-center" richColors />
          </div>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
